import { useState, useEffect } from "react";
import { getAllInvoiceNoList, getIndentInvoiceNoList } from "../services/productionService";

const useAllInvoiceNoList = () => {
    const [allInvoiceNoList, setAllInvoiceNoList] = useState([]);
    const [isInvoiceNoListLoaded, setIsInvoiceNoListLoaded] = useState(false);
    const [selectedAllInvoiceNo, setSelectedAllInvoiceNo] = useState(null);
    const [selectedAllInvoiceNoID, setSelectedAllInvoiceNoID] = useState(null);

    const fetchAllInvoiceNoList = async () => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
        };

        try {
            const data = await getAllInvoiceNoList(para);
            if (data && data.length > 0) {
                setAllInvoiceNoList(data);
                setIsInvoiceNoListLoaded(true);
            }
            else {
                setAllInvoiceNoList([]);
                setIsInvoiceNoListLoaded(false);
            }
        } catch (error) {
            throw new Error(`Error fetching invoice numbers: ${error.message}`);
        }
    };

    useEffect(() => {
        if (!isInvoiceNoListLoaded) {
            fetchAllInvoiceNoList();
        }
    }, [isInvoiceNoListLoaded]);

    const loadAllInvoiceNoByID = async (selectedIndentNo) => {
        await fetchAllInvoiceNoList(selectedIndentNo);
    };

    return {
        allInvoiceNoList,
        setAllInvoiceNoList,
        loadAllInvoiceNoByID,
        selectedAllInvoiceNo,
        setSelectedAllInvoiceNo,
        selectedAllInvoiceNoID,
        setSelectedAllInvoiceNoID
    };
};

export default useAllInvoiceNoList;
